var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--text",class:{
      sent: _vm.message.author === 'me',
      received: _vm.message.author !== 'me'
    }},[_c('p',{staticClass:"markdown-css",domProps:{"innerHTML":_vm._s(_vm.convertMarkdownToHtml(_vm.data))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-138daf19","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beautiful-chat/MarkDownTextMessage.vue
// module id = null
// module chunks = 